export default __webpack_public_path__ + "static/media/PickGift.dd6a9fd6.svg";